
















import { defineComponent, reactive } from '@vue/composition-api';
import { EntityType } from '@/store/entityModules/types';
import EntityTable from '@/components/common/EntityTable.vue';
import { DropdownFilter, IDropdownFilter } from '@/models/filters/Filters';

const Component = defineComponent({
  name: 'Category',

  components: {
    EntityTable,
  },

  setup() {
    const entityType = EntityType.CATEGORY;

    const filtersDropdown: IDropdownFilter[] = [
      new DropdownFilter({
        label: 'Parent Category',
        filterType: 'parentCategory',
        itemsModuleName: 'categoriesModule',
        hasDefaultValue: true,
      }),
    ];

    const state = reactive({
      headers: [
        { text: 'Name', value: 'name', sortable: true, searchable: true },
        {
          text: 'Image',
          value: 'thumbImage',
          align: 'center',
          sortable: false,
          editable: true,
        },
        {
          text: 'Parent Category',
          value: 'parentCategory.name',
          align: 'center',
          sortable: true,
        },
        { text: 'Position', value: 'position', align: 'center', sortable: true },
        { text: 'Details', value: 'actions', align: 'right', sortable: false },
      ],
    });

    return {
      entityType,
      state,
      filtersDropdown,
    };
  },
});
export default Component;
